export function JSONParseSafe<T>(str: unknown) {
  if (!str || typeof str !== 'string') return null;
  try {
    return JSON.parse(str) as T;
  } catch {
    return null;
  }
}
